import { routeToProduct } from '@/helpers';

import ImageCard from '@/components/@general/ImageCard/index.vue';
import StarRating from 'vue-star-rating';
import IconVerify from '@/components/icons/IconVerify.vue';

export default {
  name: 'ReviewClientCard',
  components: {
    IconVerify,
    ImageCard,
    StarRating
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isCanVerify: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {
    product() {
      return this.data.product?.data || null;
    },
    linkAttrs() {
      if (!this.product) return {};
      return {
        to: this.$localize(routeToProduct(this.product)),
        title: this.product.title
      };
    }
  },

  methods: {}
};
